import { Component, Host, h, Prop, Element, Listen } from '@stencil/core';

export interface AhaButtonGroup extends HTMLAhaButtonGroupElement {}

/**
 * @slot DEFAULT - Contents of the `<aha-button-group>` element.
 */
@Component({
  tag: 'aha-button-group',
  styleUrl: 'aha-button-group.css',
  shadow: true,
})
export class AhaButtonGroup {
  @Element() host!: HTMLAhaButtonGroupElement;

  /** Display group of buttons as "tabs" that stretch the full width of the containing element. */
  @Prop({ reflect: true }) tabs: boolean = false;

  /** Automatically select the first button in the group */
  @Prop({ reflect: true, attribute: 'auto-select' }) autoSelect: boolean = false;

  @Listen('aha-button:click')
  ahaButtonClickHandler(event: CustomEvent<HTMLAhaButtonElement>) {
    if (event.detail.hasAttribute('disabled')) return;

    Array.from(this.host.children).forEach(child => {
      const input = child.querySelector(
        'input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled])',
      );
      const checkedInput = child.querySelector(':checked:not([disabled])');

      if (child === event.detail) {
        if (input) {
          if (checkedInput) {
            child.setAttribute('active', '');
          } else {
            child.removeAttribute('active');
          }
        } else {
          child.toggleAttribute('active');
        }
      } else {
        if (!checkedInput) child.removeAttribute('active');
      }
    });
  }

  componentDidLoad() {
    if (this.autoSelect) {
      const childElements = Array.from(this.host.children);
      const hasActiveChild = childElements.find(c => c.hasAttribute('active'));
      if (hasActiveChild) return;

      const firstElement = childElements.find(c => !c.hasAttribute('disabled'));
      firstElement?.setAttribute('active', '');
    }
  }

  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }
}
